import { gsap } from "gsap";
import * as focusTrap from 'focus-trap';

let tl = false;

export default {

  setup() {

    console.log('Navigation is set up');

    const dropdownStickyNav = document.querySelector('nav.dropdown-sticky');

    if(dropdownStickyNav) {
     
      const menuBtn = dropdownStickyNav.querySelector("#menuBtn");
      const menuWrap = dropdownStickyNav.querySelector('.menu-wrap');
      const navItems = gsap.utils.toArray(".nav-item");
      const topMenuBar = dropdownStickyNav.querySelector('.top-menu-bar');
      const bottomMenuBar = dropdownStickyNav.querySelector('.bottom-menu-bar');

      var trap = focusTrap.createFocusTrap(dropdownStickyNav,{
        initialFocus: false
      });

      let menuOpen = false;

        tl = gsap.timeline().reverse();
        tl
        .to(topMenuBar, {
          rotation: 45,
          translateY: -3,
          translateX: 3,
          transformOrigin:"left top",
          duration: 0.2
        })
        .to(bottomMenuBar, {
          rotation: -45,
          translateY: 3,
          translateX: 3,
          transformOrigin:"left bottom",
          duration: 0.2
        }, "<")
        .from(menuWrap, {
          yPercent: 100,
          ease: "power2.out",
          duration: 0
        })
        .from(menuWrap, {
          autoAlpha: 0,
          duration: 0.4
        })
        .from(navItems, {
          y: -10,
          autoAlpha: 0,
          duration: 0.2,
          stagger: 0.1,
          ease: "power2.out"
        })
        ;
        const toggleMenu = () => {
          if (menuOpen) {

            // See https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/

            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);

            tl.reversed(menuOpen).progress(0);
            menuOpen = false;
            menuBtn.setAttribute("aria-expanded", menuOpen);
            menuWrap.scrollTop = 0;
            trap.deactivate();

          } else {

            document.body.style.top = '-' + window.scrollY + 'px';
            document.body.style.position = 'fixed';

            tl.reversed(menuOpen);
            menuOpen = true;
            menuBtn.setAttribute("aria-expanded", menuOpen);
            trap.activate();
          }
        };

        menuBtn.addEventListener("click", toggleMenu);
      
    }


  },
  destroy() {
    
  },
}